// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"373":"1dce86a8","528":"5cd818ec","747":"1dce86a8"}[chunkId] + ".css";
};